import { service } from '@/config/service';
import { createDatadog } from '@shg-mobile/analytics/datadog';

export const analytics = createDatadog({
  applicationId: '8d88a7be-ffe2-441d-a9e3-107a01a5dca5',
  clientToken: 'pubaf132e9d805ca4d96823814f0fd9ebed',
  site: 'datadoghq.com',
  service: service.id,
  env: import.meta.env.MODE,
  version: service.version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
});
